module.exports = {
	"data": {
		"site": {
			"siteMetadata": {
				"title": "KeystoneJS"
			}
		},
		"allMarkdownRemark": {
			"edges": [
				{
					"node": {
						"section": "Introduction",
						"slug": "/introduction/getting-started",
						"headings": [
							{
								"value": "Getting Started"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Configuration",
						"slug": "/documentation/configuration",
						"headings": [
							{
								"value": "Keystone Setup Options"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Database",
						"slug": "/documentation/database",
						"headings": [
							{
								"value": "Database Options"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Database",
						"slug": "/documentation/database/relationships",
						"headings": [
							{
								"value": "Relationships"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field",
						"headings": [
							{
								"value": "Field types"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/options",
						"headings": [
							{
								"value": "Field Options"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation List",
						"slug": "/documentation/list/add",
						"headings": [
							{
								"value": "Add"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation List",
						"slug": "/documentation/list",
						"headings": [
							{
								"value": "List"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation List",
						"slug": "/documentation/list/model",
						"headings": [
							{
								"value": "Model"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation List",
						"slug": "/documentation/list/options",
						"headings": [
							{
								"value": "List Construction Options"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation List",
						"slug": "/documentation/list/register",
						"headings": [
							{
								"value": "Register"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation List",
						"slug": "/documentation/list/schema",
						"headings": [
							{
								"value": "Schema"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation List",
						"slug": "/documentation/list/update-item",
						"headings": [
							{
								"value": "Update Item"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Methods",
						"slug": "/documentation/methods/close-database-connection",
						"headings": [
							{
								"value": "Close Database connection"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Methods",
						"slug": "/documentation/methods/create-items",
						"headings": [
							{
								"value": "Create Items"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Methods",
						"slug": "/documentation/methods/create-router",
						"headings": [
							{
								"value": "Create Router"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Methods",
						"slug": "/documentation/methods/get",
						"headings": [
							{
								"value": "Get"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Methods",
						"slug": "/documentation/methods/import",
						"headings": [
							{
								"value": "Import"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Methods",
						"slug": "/documentation/methods/importer",
						"headings": [
							{
								"value": "Importer"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Methods",
						"slug": "/documentation/methods",
						"headings": [
							{
								"value": "Methods"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Methods",
						"slug": "/documentation/methods/init",
						"headings": [
							{
								"value": "Init"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Methods",
						"slug": "/documentation/methods/list",
						"headings": [
							{
								"value": "list"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Methods",
						"slug": "/documentation/methods/middleware",
						"headings": [
							{
								"value": "Middleware"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Methods",
						"slug": "/documentation/methods/open-database-connection",
						"headings": [
							{
								"value": "Open Database Connection"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Methods",
						"slug": "/documentation/methods/paginate",
						"headings": [
							{
								"value": "Paginate"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Methods",
						"slug": "/documentation/methods/pre",
						"headings": [
							{
								"value": "Pre"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Methods",
						"slug": "/documentation/methods/set",
						"headings": [
							{
								"value": "Set"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Methods",
						"slug": "/documentation/methods/start",
						"headings": [
							{
								"value": "Start"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Methods",
						"slug": "/documentation/methods/update-handler",
						"headings": [
							{
								"value": "Update Handler"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation View",
						"slug": "/documentation/view",
						"headings": [
							{
								"value": "View"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation View",
						"slug": "/documentation/view/on",
						"headings": [
							{
								"value": "on"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation View",
						"slug": "/documentation/view/query",
						"headings": [
							{
								"value": "query"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation View",
						"slug": "/documentation/view/render",
						"headings": [
							{
								"value": "render"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides",
						"slug": "/guides/api-file-image-uploads",
						"headings": [
							{
								"value": "API File and Image Uploads"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides",
						"slug": "/guides/how-to-create-a-blog-with-keystone",
						"headings": [
							{
								"value": "How to create a blog with Keystone"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides",
						"slug": "/guides/how-to-send-emails",
						"headings": [
							{
								"value": "How to send emails with Keystone"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides",
						"slug": "/guides",
						"headings": [
							{
								"value": "Guides"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides",
						"slug": "/guides/v-0-3-to-v-4-0-upgrade-guide",
						"headings": [
							{
								"value": "Upgrade Guide: 0.3 to 4.0"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides",
						"slug": "/guides/yo-generator",
						"headings": [
							{
								"value": "Keystone Yeoman Generator"
							},
							{
								"value": "Routes & Views"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides Setting Up",
						"slug": "/guides/setting-up/part-1",
						"headings": [
							{
								"value": "Part 1: Initial Setup"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides Setting Up",
						"slug": "/guides/setting-up/part-2",
						"headings": [
							{
								"value": "Part 2 - Database Setup"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides Setting Up",
						"slug": "/guides/setting-up/part-3",
						"headings": [
							{
								"value": "Part 3: Routing"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides Setting Up",
						"slug": "/guides/setting-up/part-4",
						"headings": [
							{
								"value": "Part 4 -  Adding data to the database from a form"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/azurefile",
						"headings": [
							{
								"value": "AzureFile Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/embedly",
						"headings": [
							{
								"value": "Embedly Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/file",
						"headings": [
							{
								"value": "File Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/localfile",
						"headings": [
							{
								"value": "LocalFile Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/localfiles",
						"headings": [
							{
								"value": "Local Files"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/s-3-file",
						"headings": [
							{
								"value": "S3 File Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/boolean",
						"headings": [
							{
								"value": "Boolean Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/cloudinaryimage",
						"headings": [
							{
								"value": "CloudinaryImage Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/cloudinaryimages",
						"headings": [
							{
								"value": "CloudinaryImages Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/code",
						"headings": [
							{
								"value": "Code Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/color",
						"headings": [
							{
								"value": "Color Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/date",
						"headings": [
							{
								"value": "Date Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/datearray",
						"headings": [
							{
								"value": "Datearray field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/datetime",
						"headings": [
							{
								"value": "DateTime Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/email",
						"headings": [
							{
								"value": "Email Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/geopoint",
						"headings": [
							{
								"value": "GeoPoint Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/html",
						"headings": [
							{
								"value": "HTML Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/key",
						"headings": [
							{
								"value": "Key Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/location",
						"headings": [
							{
								"value": "Location Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/markdown",
						"headings": [
							{
								"value": "Markdown Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/money",
						"headings": [
							{
								"value": "Money Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/name",
						"headings": [
							{
								"value": "Name Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/number",
						"headings": [
							{
								"value": "Number Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/numberarray",
						"headings": [
							{
								"value": "NumberArray field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/password",
						"headings": [
							{
								"value": "Password Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/relationship",
						"headings": [
							{
								"value": "Relationship Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/select",
						"headings": [
							{
								"value": "Select Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/text",
						"headings": [
							{
								"value": "Text Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/textarea",
						"headings": [
							{
								"value": "Textarea Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/textarray",
						"headings": [
							{
								"value": "Textarray Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Field",
						"slug": "/documentation/field/url",
						"headings": [
							{
								"value": "URL Field"
							}
						]
					}
				}
			]
		},
		"markdownRemark": {
			"parent": {
				"relativePath": "Documentation/Methods/middleware.md"
			},
			"slug": "/documentation/methods/middleware",
			"headings": [
				{
					"value": "Middleware"
				}
			],
			"html": "<h1 id=\"middleware\"><a href=\"#middleware\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Middleware</h1>\n<p>Middleware are functions that run before or after particular actions, normally to perform an authentication action, or to add extra information. For a full explanation of middleware, we recommend reading the express documentation on <a href=\"https://expressjs.com/en/guide/using-middleware.html\">middleware</a>.</p>\n<p>Keystone includes some middleware automatically, to handle login and auth.</p>\n<p>All of keystone’ middleware aside from the <code>pre:render</code> middleware are intended to run only within keystone-specific routes, and are added to the express router after your own routes have been registered.</p>\n<p>In keystone, there are a number of middleware that can be added globally, which will then be called at defined times during routing. These can be passed into the <a href=\"/methods/set\">set</a> method. These are:</p>\n<table>\n<thead>\n<tr>\n<th>name</th>\n<th>call time</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td><code>pre:static</code></td>\n<td></td>\n</tr>\n<tr>\n<td><code>pre:logger</code></td>\n<td></td>\n</tr>\n<tr>\n<td><code>pre:bodyparser</code></td>\n<td></td>\n</tr>\n<tr>\n<td><code>pre:session</code></td>\n<td></td>\n</tr>\n<tr>\n<td><code>pre:admin</code></td>\n<td></td>\n</tr>\n<tr>\n<td><code>pre:routes</code></td>\n<td></td>\n</tr>\n<tr>\n<td><code>pre:render</code></td>\n<td>Called before a keystone \n<a href=\"/view\">view</a>\n is rendered.</td>\n</tr>\n<tr>\n<td><code>updates</code></td>\n<td></td>\n</tr>\n<tr>\n<td><code>signin</code></td>\n<td>Called before a user signs in to the keystone admin UI and the user is returned a view.</td>\n</tr>\n<tr>\n<td><code>signout</code></td>\n<td>Called before a user signs out of the admin UI and hte user is returned a view.</td>\n</tr>\n</tbody>\n</table>\n<p>TK - find out more about these</p>"
		}
	},
	"pathContext": {
		"slug": "/documentation/methods/middleware"
	}
};


//////////////////
// WEBPACK FOOTER
// ./.intermediate-representation/json/documentation-methods-middleware.json
// module id = ./.intermediate-representation/json/documentation-methods-middleware.json
// module chunks = 36